import { useEffect, useState } from 'react';
import axios from 'axios';

export const useAddressCountries = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    let active = true;

    axios.get('/formal-quote/address-options.json')
      .then((response) => {
        if (active) setCountries(response.data);
      })
      // The form stays usable if the request fails; server-side validation remains authoritative.
      .catch(() => {});

    return () => {
      active = false;
    };
  }, []);

  return countries;
};
